<template>
  <div class="container my-1">
    <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>
    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ i }}
        </b-alert>
      </p>
    </div>
    <div v-if="mostrarMensagemDebitosInexistentes" class="pb-1">
      <p>
        <b-alert show variant="warning" dismissible>
          <b-icon variant="warning" icon="exclamation-diamond-fill" />
          Não existe(m) débito(s) para esta pesquisa. Solicite a CND (certidão
          negativa de débitos) clicando
          <a href="http://cndonline.siatu.pbh.gov.br/CNDOnline" target="_blank"
            >aqui</a
          >.
        </b-alert>
      </p>
    </div>
    <p></p>
    <div style="text-align: center">
      <loading :active.sync="carregando" :is-full-page="true"></loading>
    </div>
    <h2 class="title"><i>Perguntas frequentes</i></h2>
    <b-card>
      <div v-for="(collapse, index) of collapses" :key="index">
        <b-button
          size="sm"
          class="mb-2 mr-2"
          v-b-toggle="'collapse-1' + index"
          variant="light"
          @click="toggle(collapse)"
        >
          <b-icon
            :icon="collapse.mostrarFilhos ? 'chevron-up' : 'chevron-down'"
            aria-hidden="true"
            id="'collapse-1' + index"
          ></b-icon>
        </b-button>
        <a :style="collapse.mostrarFilhos ? 'color:blue' : 'color:gray'">
          <b style="font-size: 20px">{{ collapse.DESCRICAO }}</b></a
        >

        <b-collapse :id="'collapse-1' + index" class="mt-2 ml-5">
          <div
            v-for="(item, index1) of collapse.PERGUNTAS_RESPOSTAS"
            :key="index1"
          >
            <b-button
              size="sm"
              class="mb-2 mr-2"
              v-b-toggle="'collapse-1-inner' + index + index1"
              variant="light"
              @click="toggleNetos(item)"
            >
              <b-icon
                :icon="item.mostrarNetos ? 'chevron-up' : 'chevron-down'"
                aria-hidden="true"
                id="'collapse-1' + index + index1"
              ></b-icon>
            </b-button>
            <a :style="item.mostrarNetos ? 'color:blue' : 'color:gray'">
              <b style="font-size: 17px">{{ item.PERGUNTA }}</b></a
            >

            <b-row class="mb-0">
              <b-col ml="0" md="11">
                <b-collapse
                  :id="'collapse-1-inner' + index + index1"
                >
                  <div class="mb-3" style="font-size: 15px">
                     {{ item.RESPOSTA_INICIO }}
                    <a   v-if="item.URL !== ''"
                         :href="item.URL" 
                         target="_blank"> aqui
                    </a>
                    {{ item.RESPOSTA_FIM }}   
                  </div>
                </b-collapse>
              </b-col>
            </b-row>
          </div>
        </b-collapse>
        <hr />
      </div>
    </b-card>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import constantes from "../constants/index";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";

export default {
  components: {
    loading,
  },
  directives: {
    mask,
  },
  data() {
    return {
      lista: [],
      aURL: "",
      posicaoInicialPreLink: 0,

      textoAll: "",
      link: "",
      carregando: false,
      origemAcesso: "",
      mensagemSucesso: [],
      mensagemErro: [],
      mostrarMensagemDebitosInexistentes: false,
      erroValidacaoIdentificador: "",
      mensagemValidacaoIdentificador: "",

      isOpen: 0,
      collapses: [
      ],

      dadosDRAM: {
        numeroDram: "",
      },

      informacaoDram: {
        idDram: "",
      },

      tokens: {
        L: {
          pattern: /[A-Za-z ]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
      },
    };
  },
  methods: {
    montaLista: function(respostas) {      
      let tabela = [];
      for (let i = 0, l = respostas.length; i < l; i++) {
          let agrupamentos = {};
          agrupamentos.DATA_DESATIVACAO = respostas[i].DATA_DESATIVACAO;
          agrupamentos.DATA_INCLUSAO = respostas[i].DATA_INCLUSAO;
          agrupamentos.DESCRICAO = respostas[i].DESCRICAO;
          agrupamentos.ID_DRAM_AGRUPA_PERGUNTAS = respostas[i].ID_DRAM_AGRUPA_PERGUNTAS;     
          agrupamentos.ID_OPERADOR_DESATIVACAO = respostas[i].ID_OPERADOR_DESATIVACAO,
          agrupamentos.ID_OPERADOR_INCLUSAO = respostas[i].ID_OPERADOR_INCLUSAO;
          agrupamentos.MENSAGEM_RETORNO = respostas[i].MENSAGEM_RETORNO;
          agrupamentos.PERGUNTAS_RESPOSTAS = [];
          if (respostas[i].PERGUNTAS_RESPOSTAS != null) {   
            for (let x = 0, k = respostas[i].PERGUNTAS_RESPOSTAS.length; x < k; x++) {
                  let subnivel = {};
                  subnivel.DATA_DESATIVACAO = respostas[i].PERGUNTAS_RESPOSTAS[x].DATA_DESATIVACAO;
                  subnivel.DATA_INCLUSAO = respostas[i].PERGUNTAS_RESPOSTAS[x].DATA_INCLUSAO;
                  subnivel.ID_DRAM_AGRUPA_PERGUNTAS = respostas[i].PERGUNTAS_RESPOSTAS[x].ID_DRAM_AGRUPA_PERGUNTAS;
                  subnivel.ID_DRAM_PERGUNTAS_RESPOSTAS = respostas[i].PERGUNTAS_RESPOSTAS[x].ID_DRAM_PERGUNTAS_RESPOSTAS;
                  subnivel.ID_OPERADOR_DESATIVACAO =  respostas[i].PERGUNTAS_RESPOSTAS[x].ID_OPERADOR_DESATIVACAO;
                  subnivel.ID_OPERADOR_INCLUSAO = respostas[i].PERGUNTAS_RESPOSTAS[x].ID_OPERADOR_INCLUSAO;
                  subnivel.PERGUNTA = respostas[i].PERGUNTAS_RESPOSTAS[x].PERGUNTA;
                  subnivel.RESPOSTA = respostas[i].PERGUNTAS_RESPOSTAS[x].RESPOSTA;
                  subnivel.RESPOSTA_INICIO = this.retornaRespostaPreLink(respostas[i].PERGUNTAS_RESPOSTAS[x].RESPOSTA);
                  subnivel.RESPOSTA_FIM = this.retornaRespostaPosLink(respostas[i].PERGUNTAS_RESPOSTAS[x].RESPOSTA);
                  subnivel.URL =  this.retornaURL(respostas[i].PERGUNTAS_RESPOSTAS[x].RESPOSTA);

                  agrupamentos.PERGUNTAS_RESPOSTAS.push(subnivel);
            }
          }        
        
          tabela.push(agrupamentos);
      }
    
      return tabela;

    },

    retornaRespostaPreLink: function (resposta) { 
      let aRespostaPreLink = "";
      this.posicaoInicialPreLink = resposta.indexOf("www"); // procura por www
      if (this.posicaoInicialPreLink < 0) {
        // não encontrou
        this.posicaoInicialPreLink = resposta.indexOf("http"); // procura por http
      }
      if (this.posicaoInicialPreLink >= 0) {
        let valorStr = resposta.substring(this.posicaoInicialPreLink); // retorna o substring a partir da posicaoInicialPreLink
        if (valorStr != "") {
          let palavras = valorStr.split(" "); // divide o valorStr em palavras
          this.link = palavras[0];
        }
      } else {
           this.posicaoInicialPreLink = resposta.length;
      }
      aRespostaPreLink = resposta.substring(0, this.posicaoInicialPreLink);       
       return aRespostaPreLink;
    },

    retornaRespostaPosLink: function (resposta) { 
      let aRespostaPosLink = "";
       aRespostaPosLink = resposta.substring(this.posicaoInicialPreLink + this.link.length);       
       return aRespostaPosLink;
    },

    retornaURL: function (resposta) { 
      let aURL = ""; 
      if (this.posicaoInicialPreLink >= 0) {
        let valorStr = resposta.substring(this.posicaoInicialPreLink); // retorna o substring a partir da posicaoInicial
        if (valorStr != "") {
          let palavras = valorStr.split(" "); // divide o valorStr em palavras
          aURL = palavras[0];
        }
      } 
      return aURL;
    },

    toggle(mostrarFilhos) {
      this.$set(mostrarFilhos, "mostrarFilhos", !mostrarFilhos.mostrarFilhos);
    },

    toggleNetos(mostrarNetos) {
      this.$set(mostrarNetos, "mostrarNetos", !mostrarNetos.mostrarNetos);
    },

    agrupaPerguntas: async function () {
      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaPerguntas)
        .then((response) => {
          const retorno = response.data;         
          const listaPerguntas = retorno[0];         
          this.lista = this.montaLista(listaPerguntas);         
          this.collapses =  this.lista;    // listaPerguntas;                
        })
        .catch((err) => {
          this.carregandoTabelaLancamentos = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        })
        .finally(() => {
          this.carregando = false;
        });
    },
  },

  watch: {},

  computed: {},

  async beforeMount() {},

  created() {
    this.carregando = true;
    this.agrupaPerguntas();
  },

  async mounted() {
    this.parteTexto1 = "";
    this.parteTexto2 = "";
  },
};
</script>    

<style lang="css" scoped>
</style>